module.exports = __webpack_public_path__ + "images/Humana_bc30877.png";